"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _FormattedMessage = require("../FormattedMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Header = ({
  quantity
}) => {
  const {
    miniBagConfiguration: {
      goToBasketUrl
    } = {}
  } = (0, _contexts.useMiniBagConfiguration)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId('header'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h6",
      component: "p",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BasketLink, {
        href: goToBasketUrl,
        "data-testid": getTestId('header-basket-link'),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "basket"
        }), " (", quantity.toString(), ")"]
      })
    })
  });
};
exports.Header = Header;
